import React, { useState, useEffect, useMemo } from 'react';
import { Widget, GridView, SimpleView, CompositeView, MasterDetailForm, Button, FormatText } from '@digital/ui';
import RelatorioCicloOrcamentarioProjetoDadosGerais from '../RelatorioCicloOrcamentarioProjeto/dadosGerias';
import { CicloOrcamentarioProjetoDadosGerais, CicloOrcamentarioProjetoPacote } from '@app/api/relatorioCicloorcamentario';
import {
    exportarFechamentoProjetoCicloAnoPacote,
    exportarFechamentoProjetoPluriAnual,
    exportarFechamentoProjetoPluriAnualDetalado,
    getFechamentoCicloAnoGraficoCurvaProjeto,
    getFechamentoCicloAnoPacoteProjeto,
    getFechamentoCicloOrcamentarioDadosGeraisProjetoDetalhe,
    getFechamentoPluriAnualGraficoCurvaProjeto,
    getFechamentoPluriAnualPacoteProjeto,
    getFechamentoProjetoRequisitado
} from '@app/api/fechamento';
import AbaPacoteTabela from '../RelatorioCicloOrcamentarioProjetoPluriAnual/AbaPacoteTabela';
import AbaCicloOrcamentarioPacoteTabela from '../RelatorioCicloOrcamentarioProjeto/AbaCicloOrcamentarioPacoteTabela';
import { ReportCicloOrcamentario } from '@app/api/relatorios';
import GraficoCurva from '../GraficoCurva';
import { Collapse, Icon } from 'antd';
import CurvaPluriAnualGrafico from '../GraficoCurvaPluriAnual/curvaPluriAnualGrafico';

import { RequisitadoComOrdemCompra, RequisitadoRc, RequisitadoSemOrdemCompra } from '@app/api/projeto';
import DetalheProjetoFechamentoRequisitado from './detalheProjetoFechamentoRequisitado';
import FormTableRequisitadoCompraProjeto from '../Projeto/FormTableRequisitadoCompraProjeto';
import FormTableRequisitadoCompraOrdemCompraProjeto from '../Projeto/FormTableRequisitadoCompraOrdemCompraProjeto';

const { Panel } = Collapse;


const DetalheProjetoFechamento = () => {

    const [fechamentoId, setFechamentoId] = useState<string>();
    const [projetoId, setProjetoId] = useState<string>();
    const [cicloOrcamentarioProjetoDadosGerais, setCicloOrcamentarioProjetoDadosGerais] = useState<CicloOrcamentarioProjetoDadosGerais>();
    const [cicloOrcamentarioProjetoPacotePluriAnual, setCicloOrcamentarioProjetoPacotePluriAnual] = useState<CicloOrcamentarioProjetoPacote>();
    const [cicloOrcamentarioProjetoPacote, setCicloOrcamentarioProjetoPacote] = useState<CicloOrcamentarioProjetoPacote>();
    const [relatorioGraficoCurvaCicloAno, setRelatorioGraficoCurvaCicloAno] = useState<ReportCicloOrcamentario>();
    const [relatorioGraficoCurvaCicloAnoPluriAnual, setRelatorioGraficoCurvaCicloAnoPluriAnual] = useState<ReportCicloOrcamentario>();
    const [requisitado, setRequisitado] = useState<RequisitadoRc[]>();

    const [requisitoCompra, setRequisitoCompra] = useState<RequisitadoSemOrdemCompra[]>();
    const [requisitoComOrdemCompra, setRequisitoComOrdemCompra] = useState<RequisitadoComOrdemCompra[]>();
    const [displayWidgetRequisitado, setDisplayWidgetRequisitado] = useState({ display: 'none' });
    const [displayWidgetContratado, setDisplayWidgetContratado] = useState({ display: 'none' });

    useEffect(() => {
        let fechamentoIdParamens = new URLSearchParams(window.location.search).get('fechamentoId');
        let projetoIdParamens = new URLSearchParams(window.location.search).get('projetoId');
        if (fechamentoIdParamens && projetoIdParamens) {
            setFechamentoId(fechamentoIdParamens);
            setProjetoId(projetoIdParamens);
        }
    }, []);

    useMemo(async () => {
        if (fechamentoId && projetoId) {

            const resultDadosGerais = await getFechamentoCicloOrcamentarioDadosGeraisProjetoDetalhe(fechamentoId, projetoId);
            if (resultDadosGerais) {
                setCicloOrcamentarioProjetoDadosGerais(resultDadosGerais);
            }

            const resultCicloOrcamentarioProjetoPacotePluriAnual = await getFechamentoCicloAnoPacoteProjeto(fechamentoId, projetoId);
            if (resultCicloOrcamentarioProjetoPacotePluriAnual) {
                setCicloOrcamentarioProjetoPacote(resultCicloOrcamentarioProjetoPacotePluriAnual);
            }

            const resultRelatorioGraficoCurvaCicloAno = await getFechamentoCicloAnoGraficoCurvaProjeto(fechamentoId, projetoId);
            if (resultRelatorioGraficoCurvaCicloAno) {
                setRelatorioGraficoCurvaCicloAno(resultRelatorioGraficoCurvaCicloAno);
            }


            const resultPluriAnualProjetoPacotePluriAnual = await getFechamentoPluriAnualPacoteProjeto(fechamentoId, projetoId);
            if (resultPluriAnualProjetoPacotePluriAnual) {
                setCicloOrcamentarioProjetoPacotePluriAnual(resultPluriAnualProjetoPacotePluriAnual);
            }

            const data = await getFechamentoPluriAnualGraficoCurvaProjeto(fechamentoId, projetoId)
            if (data) {
                if (data) {
                    if (data.serieDataForeCastLinha) {
                        for (var i = 0; i < data.serieDataForeCastLinha.length; i++) {
                            if (data.serieDataForeCastLinha[i] <= 0) {
                                data.serieDataForeCastLinha[i] = null;
                            }
                        }
                    }

                    if (data.serieDataOrcadoLinha) {
                        for (var i = 0; i < data.serieDataOrcadoLinha.length; i++) {
                            if (data.serieDataOrcadoLinha[i] <= 0) {
                                data.serieDataOrcadoLinha[i] = null;
                            }
                        }
                    }

                    if (data.serieDataExecutadoLinha) {
                        for (var i = 0; i < data.serieDataExecutadoLinha.length; i++) {
                            if (data.serieDataExecutadoLinha[i] <= 0) {
                                data.serieDataExecutadoLinha[i] = null;
                            }
                        }
                    }


                    if (data.serieDataExecutado) {
                        for (var i = 0; i < data.serieDataExecutado.length; i++) {
                            if (data.serieDataExecutado[i] <= 0) {
                                data.serieDataExecutado[i] = null;
                            }
                        }
                    }

                    if (data.serieDataOrcado) {
                        for (var i = 0; i < data.serieDataOrcado.length; i++) {
                            if (data.serieDataOrcado[i] <= 0) {
                                data.serieDataOrcado[i] = null;
                            }
                        }
                    }

                    if (data.serieDataForeCast) {
                        for (var i = 0; i < data.serieDataForeCast.length; i++) {
                            if (data.serieDataForeCast[i] <= 0) {
                                data.serieDataForeCast[i] = null;
                            }
                        }
                    }

                }
                setRelatorioGraficoCurvaCicloAnoPluriAnual(data)
            }

            const resultRequisitado = await getFechamentoProjetoRequisitado(fechamentoId, projetoId);
            if (resultRequisitado) {
                setRequisitado(resultRequisitado);
            }

        }
    }, [projetoId]);




    const btnExportar = () => {
        return [
            <Button
                type="primary"
                name="btnExportar"
                icon="files-ms_excel"
                onClick={() => {
                    exportarFechamentoProjetoCicloAnoPacote(fechamentoId, projetoId, 'fechamentoProjetoCicloAnoPacote.xlsx');
                }}>
                <FormatText id="data-export" uppercase transform={() => "Exportar Relatório"} />
            </Button>,
        ]
    }


    const btnExportarPluriAnual = () => {
        return [
            <Button
                type="link"
                name="btnExportar"
                icon="files-ms_excel"
                onClick={() => {
                    exportarFechamentoProjetoPluriAnualDetalado(fechamentoId, projetoId, 'relatorioDetalhado.xlsx');
                }}>
                <FormatText id="data-export" uppercase transform={() => "Exportar Relatório Detalhado"} />
            </Button>,
            <Button
                type="primary"
                name="btnExportar"
                icon="files-ms_excel"
                onClick={() => {
                    exportarFechamentoProjetoPluriAnual(fechamentoId, projetoId, 'projetoPluriAnualPacote.xlsx');
                }}>
                <FormatText id="data-export" uppercase transform={() => "Exportar Relatório"} />
            </Button>
        ]
    }


    const handleTabelaSemOrdemRequistado = (result: RequisitadoSemOrdemCompra[], st: any) => {
        if (result && result.length > 0) {
            setRequisitoCompra(result);
            setDisplayWidgetRequisitado({ display: 'block' });
        } else {
            setRequisitoCompra([]);
            //setDisplayWidgetRequisitado({ display: 'none' });
        }
    };

    const handleTabelaComOrdemRequistado = (result: RequisitadoComOrdemCompra[], st: any) => {
        if (result && result.length > 0) {
            setRequisitoComOrdemCompra(result);
            setDisplayWidgetRequisitado({ display: 'block' });
        } else {
            setRequisitoComOrdemCompra([]);
            //setDisplayWidgetRequisitado({ display: 'none' });
        }
    };


    return (
        <SimpleView>
            <GridView noform>
                <CompositeView>

                    {true && fechamentoId && projetoId && cicloOrcamentarioProjetoDadosGerais ? (
                        <GridView icon="files-new_by_copy" id={`dadosGerais`} noform title="DADOS GERAIS">
                            <RelatorioCicloOrcamentarioProjetoDadosGerais
                                cicloOrcamentarioProjetoDadosGerais={cicloOrcamentarioProjetoDadosGerais}
                            />
                        </GridView>
                    ) : (
                        () => { }
                    )}

                    {true && fechamentoId && projetoId && cicloOrcamentarioProjetoPacote && relatorioGraficoCurvaCicloAno ? (
                        <GridView icon="files-new_by_copy" id="cicoOrcamentario" noform title="CICLO ORÇAMENTARIO">
                            <Collapse bordered={false} defaultActiveKey={['1']} expandIcon={() => <Icon type="arrows-right_4" />}>
                                <Panel key="1" header="RESULTADO" style={{ border: 0 }}>
                                    <MasterDetailForm>
                                        <Widget actions={btnExportar()}>
                                            <AbaCicloOrcamentarioPacoteTabela
                                                cicloOrcamentarioProjetoPacote={cicloOrcamentarioProjetoPacote}
                                                pageSize={10}
                                                projetoId={projetoId}
                                            />
                                        </Widget>
                                    </MasterDetailForm>
                                </Panel>
                            </Collapse>

                            <Collapse bordered={false} defaultActiveKey={['2']} expandIcon={() => <Icon type="arrows-right_4" />}>
                                <Panel key="2" header="GRÁFICO" style={{ border: 0 }}>
                                    <MasterDetailForm>
                                        <Widget>
                                            <GraficoCurva relatorio={relatorioGraficoCurvaCicloAno} carregarTabela={true} />
                                        </Widget>
                                    </MasterDetailForm>
                                </Panel>
                            </Collapse>


                        </GridView>
                    ) : (
                        () => { }
                    )}

                    {true && fechamentoId && projetoId && cicloOrcamentarioProjetoPacotePluriAnual && relatorioGraficoCurvaCicloAnoPluriAnual ? (
                        <GridView icon="files-new_by_copy" id="pluriAnual" noform title="PLURIANUAL">
                            <>

                                <Collapse bordered={false} defaultActiveKey={['1']} expandIcon={() => <Icon type="arrows-right_4" />}>
                                    <Panel key="1" header="RESULTADO" style={{ border: 0 }}>
                                        <MasterDetailForm>
                                            <Widget actions={btnExportarPluriAnual()}>
                                                <AbaPacoteTabela
                                                    projetoId={projetoId}
                                                    pageSize={10}
                                                    cicloOrcamentarioProjetoPacotePluriAnual={cicloOrcamentarioProjetoPacotePluriAnual}
                                                />
                                            </Widget>
                                        </MasterDetailForm>
                                    </Panel>
                                </Collapse>

                                <Collapse bordered={false} defaultActiveKey={['2']} expandIcon={() => <Icon type="arrows-right_4" />}>
                                    <Panel key="2" header="GRÁFICO" style={{ border: 0 }}>
                                        <MasterDetailForm>
                                            <Widget>
                                                <CurvaPluriAnualGrafico
                                                    relatorio={relatorioGraficoCurvaCicloAnoPluriAnual}
                                                    carregarTabela={true}
                                                />
                                            </Widget>
                                        </MasterDetailForm>
                                    </Panel>
                                </Collapse>

                            </>
                        </GridView>

                    ) : (
                        () => { }
                    )}

                    {true && fechamentoId && projetoId && requisitado ? (
                        <GridView icon="files-new_by_copy" id="requisitado" noform title="REQUISITADO">
                            <>
                                <Collapse bordered={false} defaultActiveKey={['1']} expandIcon={() => <Icon type="arrows-right_4" />}>
                                    <Panel key="1" header="RESULTADO" style={{ border: 0 }}>
                                        <MasterDetailForm>
                                            <DetalheProjetoFechamentoRequisitado
                                                requisitadoRc={requisitado}
                                                projetoId={projetoId}
                                                fechamentoId={fechamentoId}
                                                handleTabelaSemOrdemRequistado={handleTabelaSemOrdemRequistado}
                                                handleTabelaComOrdemRequistado={handleTabelaComOrdemRequistado}
                                            />
                                        </MasterDetailForm>
                                    </Panel>
                                </Collapse>


                                <FormTableRequisitadoCompraProjeto
                                    requisitoCompra={requisitoCompra || []}
                                    projetoId={(projetoId) || ''}
                                    style={displayWidgetRequisitado}
                                />


                                <FormTableRequisitadoCompraOrdemCompraProjeto
                                    requisitoComOrdemCompra={requisitoComOrdemCompra || []}
                                    projetoId={(projetoId) || ''}
                                    style={displayWidgetRequisitado}
                                />


                            </>
                        </GridView>

                    ) : (
                        () => { }
                    )}
                </CompositeView>
            </GridView>
        </SimpleView>
    );
};

export default DetalheProjetoFechamento;
